"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @hidden
 */
var canUseDOM = Boolean(
// from fbjs
typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement);
exports.canUseDOM = canUseDOM;
//# sourceMappingURL=canUseDOM.js.map